import { ConsumptionVariance } from '@app/models/dyeing-dashboard/batch-consumption-estimate';
import { ProductionCardDyeingCycle } from '@app/models/dyeing-dashboard/production-card-dyeing-cycle';
import { Requisition } from '@app/models/inventory/requisition';
import { ProductRecipe } from '@app/models/item/product-recipe';
import { EntityKeyByReference } from '@app/models/production/production-work-order';
import { Note, StatusHistoryEntry } from '@app/models/shared/common-entities';
import { TagView } from '@app/models/shared/tag';

export interface Batch {
  id: string;
  number: string;
  status: BatchStatus;
  type: BatchType;
  productDevelopmentNumber: string;
  productRecipe?: ProductRecipe;
  uom: number;
  initiator: EntityKeyByReference;
  plannedQuantity: number;
  actualQuantity?: number;
  assetId?: string;
  notes?: Note[];
  statusHistory?: StatusHistoryEntry<BatchStatus>[];
  manufacturerLotNumber?: string;
  isManufacturerLotNumberLocked?: boolean;
  expiryDate?: Date;
  isExpiryDateLocked?: boolean;
}

export enum BatchStatus {
  Draft = 0,
  Approved = 1,
  ReadyForProduction = 2,
  InProduction = 3,
  Completed = 4,
  Closed = 5,
  Cancelled = 98,
  Deleted = 99,
}

export enum BatchType {
  Chemical = 0,
}

export interface BatchInsert {
  status: BatchStatus;
  type: BatchType;
  productDevelopmentNumber: string;
  uom: number;
  initiator: EntityKeyByReference;
  plannedQuantity: number;
  assetId?: string;
  notes?: Note[];
}

export interface BatchSearchCommand {
  number?: string;
  initiatorReference?: string;
  status?: BatchStatus[];
  productDevelopmentNumber?: string;
  type?: BatchType;
}

export interface BatchDyeingCycleRow {
  cycle: ProductionCardDyeingCycle;
  approval: TagView;
  isCompleted: boolean;
}

export interface BatchConsumptionSummaryRow {
  labelKey: string;
  fallback: string;
  unit: string;
  estimated: number | null;
  actual: number;
  variance: ConsumptionVariance | null;
}

export interface BatchRequisitionRow {
  requisition: Requisition;
  status: TagView;
}

export interface ClientPOAllocation {
  clientPurchaseOrderReference: string;
  clientPurchaseOrderNumber: string;
  clientPurchaseOrderProductRecipeNumber: string;
  reservedQuantity: number;
}
